<template>
  <div v-if="loading" class="login-page">
    <v-layout class="login-container">
      <div class="mb-3">
        <div style="justify-items: center">
          <v-img
            v-if="logoPath"
            :src="logoPath"
            alt="Customer Logo"
            class="customer-logo mb-2"
            width="100"
          ></v-img>
          <v-img
            :src="`${siteUrl}/images/SPHEREboard_Logo_2024_white.svg`"
            alt="SPHEREboard Logo"
            width="220"
          ></v-img>
        </div>
      </div>
      <div v-if="showWarning" class="warning-message">
        <span>{{ errorMessage }}</span>
      </div>
      <v-form ref="login_form" v-model="valid" class="input-fields">
        <v-text-field
          v-if="idpTypeNames.find((x) => x == 'Local Active Directory')"
          v-model="userName"
          class="bordered-input"
          label="Username"
          :rules="[(v) => (v != null && !!v) || 'Username is required']"
          placeholder="Enter username"
          @keydown.enter="continueWithLocalAD"
        ></v-text-field>
        <v-text-field
          v-if="idpTypeNames.find((x) => x == 'Local Active Directory')"
          v-model="password"
          :append-icon="visible ? 'visibility' : 'visibility_off'"
          :type="visible ? 'text' : 'password'"
          class="bordered-input password-input-size"
          label="Password"
          placeholder="Enter password"
          :rules="[(v) => (v != null && !!v) || 'Password is required']"
          @click:append="visible = !visible"
          @keydown.enter="continueWithLocalAD"
        ></v-text-field>
        <v-btn
          v-if="idpTypeNames.find((x) => x == 'Local Active Directory')"
          color="#fdb913"
          class="btn-custom"
          size="large"
          @click="continueWithLocalAD"
          >Continue</v-btn
        >
        <v-layout
            v-if="
            idpTypeNames.find((x) => x == 'Local Active Directory') &&
            (idpTypeNames.find((x) => x == 'Microsoft Entra') ||
            idpTypeNames.find((x) => x == 'Okta') ||
            idpTypeNames.find((x) => x == 'PingOne') ||
            idpTypeNames.find((x) => x == 'PingFederate'))
            "
            class="login-divider py-2"
            align-center
            >
            <v-flex>
                <v-divider class="divider"></v-divider>
            </v-flex>
            <div class="px-3">
                <span class="color_white">or</span>
            </div>
            <v-flex>
                <v-divider class="divider"></v-divider>
            </v-flex>
        </v-layout>
        <v-btn
          v-if="idpTypeNames.find((x) => x == 'Microsoft Entra')"
          :color="
            idpTypeNames.find((x) => x == 'Local Active Directory')
              ? '#cfdce7'
              : '#fdb913'
          "
          class="btn-custom mt-2 d-flex align-center justify-center"
          size="large"
          @click="continueWithMicrosoft"
        >
          <v-img
            :src="`${siteUrl}/images/EntraID.png`"
            alt="Microsoft Logo"
            class="mr-2"
            contain
            max-height="24"
            max-width="24"
          />
          {{ getConfigurationName('Microsoft Entra') }}</v-btn
        >
        <v-btn
          v-if="idpTypeNames.find((x) => x == 'Okta')"
          :color="
            idpTypeNames.find((x) => x == 'Local Active Directory')
              ? '#cfdce7'
              : '#fdb913'
          "
          class="btn-custom d-flex align-center justify-center"
          :class="
            idpTypeNames.find((x) => x == 'Microsoft Entra') ? 'mt-3' : 'mt-2'
          "
          size="large"
          @click="continueWithOkta"
        >
          <v-img
            :src="`${siteUrl}/images/okta_logo.png`"
            alt="Okta Logo"
            class="mr-2"
            contain
            max-height="24"
            max-width="24"
          />{{ getConfigurationName('Okta') }}</v-btn
        >
        <v-btn
          v-if="idpTypeNames.find((x) => x == 'PingOne')"
          :color="
            idpTypeNames.find((x) => x == 'Local Active Directory')
              ? '#cfdce7'
              : '#fdb913'
          "
          class="btn-custom d-flex align-center justify-center"
          :class="
            idpTypeNames.find((x) => x == 'Microsoft Entra' || x == 'Okta')
              ? 'mt-3'
              : 'mt-2'
          "
          size="large"
          @click="continueWithPingOne"
        >
          <v-img
            :src="`${siteUrl}/images/ping_logo.png`"
            alt="Okta Logo"
            class="mr-2"
            contain
            max-height="24"
            max-width="24"
          />{{ getConfigurationName('PingOne') }}</v-btn
        >
        <v-btn
          v-if="idpTypeNames.find((x) => x == 'PingFederate')"
          :color="
            idpTypeNames.find((x) => x == 'Local Active Directory')
              ? '#cfdce7'
              : '#fdb913'
          "
          class="btn-custom d-flex align-center justify-center"
          :class="
            idpTypeNames.find((x) => x == 'Microsoft Entra' || x == 'Okta' || x == 'PingOne')
              ? 'mt-3'
              : 'mt-2'
          "
          size="large"
          @click="continueWithPingFederate"
        >
          <v-img
            :src="`${siteUrl}/images/ping_logo.png`"
            alt="Okta Logo"
            class="mr-2"
            contain
            max-height="24"
            max-width="24"
          />{{ getConfigurationName('PingFederate') }}</v-btn
        >
      </v-form>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    returnUrl: {
      type: String,
      default: null,
    },
    authApiUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      logoPath: '',
      userName: '',
      password: '',
      activeIDPTypes: [],
      idpTypeNames: [],
      loading: false,
      visible: false,
      showWarning: false,
      getActiveIDPEndpoint: '/GetActiveIDP',
      siteUrl: document.getElementById('view-data:Sitename').value,
      errorUrl: document.getElementById('view-data:ErrorUrl').value,
      errorMessage: document.getElementById('view-data:SphereLoginError').value,
      reloadUserPermissionEndpoint: '/Splash/ReloadUserPermission',
    };
  },
  async created() {
    this.loading = false;
    await this.getLogoPath();
    await this.getActiveIdp();
    await this.InvalidCredential();
    this.loading = true;
  },
  methods: {
    async getLogoPath() {
      await axios
        .get('/GetLogo', {
          responseType: 'blob',
        })
        .then((res) => {
          if (res.status != 200) this.logoPath = null;
          else {
            const imageBlob = res.data;
            const imageUrl = URL.createObjectURL(imageBlob);
            this.logoPath = imageUrl;
          }
        });
    },
    async continueWithLocalAD() {
      if (this.valid) {
        let configId = this.activeIDPTypes.find(
        (x) => x.IDPTypeName == 'Local Active Directory'
        ).ConfigurationID;
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = `${this.siteUrl}/DoCredentialLogin`;

        const fields = {
        idpConfigurationID: configId,
        username: this.userName,
        password: this.password,
        returnUrl: this.returnUrl,
        errorUrl: this.errorUrl,
        };

        Object.keys(fields).forEach((key) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = fields[key];
        form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      } else {
        this.$refs.login_form.validate();
      }
    },
    async continueWithMicrosoft() {
      let configId = this.activeIDPTypes.find(
        (x) => x.IDPTypeName == 'Microsoft Entra'
      ).ConfigurationID;
      await axios.get(this.reloadUserPermissionEndpoint);
      // Redirect the user to the WebAPI authentication endpoint
      window.location.href = `${
        this.authApiUrl
      }/Auth/Login?idpConfigurationID=${configId}&returnUrl=${encodeURIComponent(
        this.returnUrl
      )}&errorUrl=${encodeURIComponent(this.errorUrl)}`;
    },
    async continueWithOkta() {
      let configId = this.activeIDPTypes.find(
        (x) => x.IDPTypeName == 'Okta'
      ).ConfigurationID;
      await axios.get(this.reloadUserPermissionEndpoint);
      // Redirect the user to the WebAPI authentication endpoint
      window.location.href = `${
        this.authApiUrl
      }/Auth/Login?idpConfigurationID=${configId}&returnUrl=${encodeURIComponent(
        this.returnUrl
      )}&errorUrl=${encodeURIComponent(this.errorUrl)}`;
    },
    async continueWithPingOne() {
      let configId = this.activeIDPTypes.find(
        (x) => x.IDPTypeName == 'PingOne'
      ).ConfigurationID;
      // Redirect the user to the WebAPI authentication endpoint
      window.location.href = `${
        this.authApiUrl
      }/Auth/Login?idpConfigurationID=${configId}&returnUrl=${encodeURIComponent(
        this.returnUrl
      )}&errorUrl=${encodeURIComponent(this.errorUrl)}`;
    },
    async continueWithPingFederate() {
      let configId = this.activeIDPTypes.find(
        (x) => x.IDPTypeName == 'PingFederate'
      ).ConfigurationID;
      // Redirect the user to the WebAPI authentication endpoint
      window.location.href = `${
        this.authApiUrl
      }/Auth/Login?idpConfigurationID=${configId}&returnUrl=${encodeURIComponent(
        this.returnUrl
      )}&errorUrl=${encodeURIComponent(this.errorUrl)}`;
    },
    async getActiveIdp() {
      let response = await axios.get('/GetActiveIDP');
      this.activeIDPTypes = response.data;

      this.idpTypeNames = [
        ...new Set(response.data.map((item) => item.IDPTypeName)),
      ];
    },
    async InvalidCredential() {
      if (this.errorMessage) this.showWarning = true;
      else this.showWarning = false;
    },
    getConfigurationName(idpName) {
      const idp = this.activeIDPTypes.find((x) => x.IDPTypeName === idpName);
      return idp && idp.ConfigurationName ? idp.ConfigurationName : idpName;
    },
  },
};
</script>

<style lang="scss">
.login-page {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: Max(600px, 100vh);
  background: url(../../images/sphereco_background.png) no-repeat center/contain;
  background-position: top right;
  background-repeat: no-repeat;
  background-size: cover;
  .input-fields {
    display: flex;
    flex-direction: column;
  }
  .bordered-input {
    margin-top: 0 !important;
    input {
      background-color: white;
      border-radius: 6px;
      .v-input.v-input--is-focused .v-label,
      .v-input.v-input--is-dirty .v-label {
        color: inherit !important;
      }
    }
    label,
    .v-label {
      color: white !important;
      font-weight: normal;
      font-size: 1.1rem;
      font-family: 'Work Sans';
    }
    input::-webkit-input-placeholder {
      color: var(--Neutral-300, #999);
      font-style: normal !important;
    }
    .v-input__control .v-input__append-inner {
      position: absolute;
      right: 10px;
      top: 64%;
      transform: translateY(-50%);
      cursor: pointer;
    }
    .v-input__control {
      .v-text-field__details {
        .v-messages__wrapper {
          color: red !important;
        }
      }
    }
  }
  .password-input-size {
    .v-input__control .v-input__slot .v-text-field__slot input {
      padding-right: 38px;
      text-overflow: clip;
    }
  }

  .login-container {
    background-color: #00538d !important;
    padding: 5rem;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
    max-width: 450px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    .warning-message {
      font-size: 1.1rem;
      margin-bottom: 6px;
      color: red !important;
    }
  }
  .sphere-logo,
  .customer-logo {
    justify-items: center;
    margin-bottom: 8px;
  }
  .btn-custom {
    border: none;
    color: black !important;
    font-weight: 600;
    font-family: 'Work Sans';
    padding: 8px;
    width: 100%;
    font-size: 1.1rem;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    gap: 15px;
    margin-left: 0px;
    margin-right: 0px;
  }
  .btn-custom:hover {
    background-color: #fdb913 !important;
  }
  .login-divider {
    .divider {
      display: flex;
      align-items: center;
      text-align: center;
      margin: 16px 0;
      background-color: #fff;
    }
  }
}
</style>
